import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface DriversIconProps {
  color?: string;
  style?: React.CSSProperties;
  height?: string;
  width?: string;
}

export default function DriversIcon({
  color = RoutalPalette.secondary60,
  style = {},
  height = `19px`,
  width = `26px`,
}: DriversIconProps) {
  return (
    <SvgIcon viewBox="0 0 26 19" style={{ fill: `none`, height: height, width: width, ...style }}>
      <path
        d="M1.36621 7.77148H24.8661"
        stroke={color}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.2461 0.771484V7.77148"
        stroke={color}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.51799 17.7715C8.16159 17.7715 9.49399 16.4283 9.49399 14.7715C9.49399 13.1146 8.16159 11.7715 6.51799 11.7715C4.87439 11.7715 3.54199 13.1146 3.54199 14.7715C3.54199 16.4283 4.87439 17.7715 6.51799 17.7715Z"
        stroke={color}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.4223 17.7715C20.0659 17.7715 21.3983 16.4283 21.3983 14.7715C21.3983 13.1146 20.0659 11.7715 18.4223 11.7715C16.7787 11.7715 15.4463 13.1146 15.4463 14.7715C15.4463 16.4283 16.7787 17.7715 18.4223 17.7715Z"
        stroke={color}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.2206 2.42948C21.7166 1.41348 20.686 0.771484 19.559 0.771484H3.35021C2.25405 0.771484 1.36621 1.66648 1.36621 2.77148V13.7715C1.36621 14.3235 1.81063 14.7715 2.35821 14.7715H3.54221C3.54221 13.1145 4.87447 11.7715 6.51821 11.7715C8.16195 11.7715 9.49421 13.1145 9.49421 14.7715H15.4462C15.4462 13.1145 16.7785 11.7715 18.4222 11.7715C20.066 11.7715 21.3982 13.1145 21.3982 14.7715H24.3742C24.9218 14.7715 25.3662 14.3235 25.3662 13.7715V8.77148L22.2206 2.42948Z"
        stroke={color}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
